// jasa.service — validasi + gating izin. Port saveJasa/saveOvr v0.18.
import { currentUser } from '@core/session';
import { cleanText } from '@domain/format';
import type { Role } from '@core/types';
import * as repo from './jasa.repo';

const canManage = (r: Role): boolean => ['Owner', 'Manager'].includes(r);
const canOverride = (r: Role): boolean => ['Owner', 'Manager', 'SPV'].includes(r);

const htNorm = (x: unknown): 'rp' | 'persen' => (x === 'persen' ? 'persen' : 'rp');

export async function saveJasa(id: number | null, nama: string, modal: number, toko: number, user: number, garansi: string, hargaTypeToko: 'rp' | 'persen' = 'rp', hargaTypeUser: 'rp' | 'persen' = 'rp'): Promise<void> {
  const u = currentUser();
  if (!u || !canManage(u.role)) throw new Error('Hanya Owner/Manager yang dapat mengelola jasa.');
  const n = cleanText(nama, 180), g = cleanText(garansi, 80);
  if (!n || !g) throw new Error('Nama dan garansi wajib diisi.');
  const d: repo.JasaInput = { nama: n, modal: modal || 0, toko: toko || 0, user: user || 0, garansi: g, harga_type_toko: htNorm(hargaTypeToko), harga_type_user: htNorm(hargaTypeUser) };
  if (id) await repo.updateService(id, d);
  else await repo.createService(d);
}

export async function deleteJasa(id: number): Promise<void> {
  const u = currentUser();
  if (!u || !canManage(u.role)) throw new Error('Hanya Owner/Manager yang dapat menghapus jasa.');
  await repo.deleteService(id);
}

/** Edit Massal: simpan hanya baris yang berubah (harga master). Port saveBulk v0.18 (O/M).
 * v0.18 saveBulk tak memblokir field kosong (hanya .trim()+tulis) → tetap faithful; cleanText hanya sanitasi. */
export async function bulkSaveJasa(rows: JasaEdit[]): Promise<number> {
  const u = currentUser();
  if (!u || !canManage(u.role)) throw new Error('Hanya Owner/Manager yang dapat edit massal jasa.');
  const clean = rows.map((r) => ({ id: r.id, nama: cleanText(r.nama, 180), modal: r.modal || 0, toko: r.toko || 0, user: r.user || 0, garansi: cleanText(r.garansi, 80), harga_type_toko: htNorm(r.hargaTypeToko), harga_type_user: htNorm(r.hargaTypeUser) }));
  for (const r of clean) await repo.updateService(r.id, { nama: r.nama, modal: r.modal, toko: r.toko, user: r.user, garansi: r.garansi, harga_type_toko: r.harga_type_toko, harga_type_user: r.harga_type_user });
  return clean.length;
}
export interface JasaEdit { id: number; nama: string; modal: number; toko: number; user: number; garansi: string; hargaTypeToko?: 'rp' | 'persen'; hargaTypeUser?: 'rp' | 'persen' }

export async function saveOverride(serviceId: number, outlet: string, toko: number, user: number): Promise<void> {
  const u = currentUser();
  if (!u || !canOverride(u.role)) throw new Error('Tidak punya izin override harga cabang.');
  if (!outlet) throw new Error('Pilih cabang.');
  await repo.upsertOverride({ service_id: serviceId, outlet, toko: toko || 0, user: user || 0 });
}

export async function clearOverride(serviceId: number, outlet: string): Promise<void> {
  const u = currentUser();
  if (!u || !canOverride(u.role)) throw new Error('Tidak punya izin.');
  await repo.deleteOverride(serviceId, outlet);
}
